import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { DividaResource } from '@/models/resources';

const useHeaderCredorDestaqueStore = defineStore('headerCredorDestaque', () => {
  const divida = ref<DividaResource | null>(null);

  function definir(dividaDestaque: DividaResource) {
    divida.value = dividaDestaque;
  }

  function limpar() {
    divida.value = null;
  }

  return {
    divida,
    definir,
    limpar,
  };
});

export default useHeaderCredorDestaqueStore;
